import React, { useState, useEffect, useContext } from "react";
import "./updateSchedule.scss";
import Visibility from "../../../../assets/visibility.png";
import RedTrash from "../../../../assets/redTrash.png";
import { Button } from "react-bootstrap";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import TimePickerModal from "../Modals/TimePickerModal";
import moment from "moment";
import MyScheduleModal from "../Modals/MyScheduleModal";
import Loader from "../../../UI Component/Loader/Loader";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import info_icon from "../../../../assets/dashboard/info_icon.svg";
import DelayMarkedPopup from "./DelayMarkedPopup";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { DAYS_OF_WEEK } from "../Constants";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";

function AddTimeRange(props) {
  const {
    consultationType,
    slotValue,
    handleViewSlots,
    disableAddBtn,
    consultationCounter,
    staffDoctor,
    handleShowDelayMarkedPopup,
    commonProcedure,
  } = props;

  const [openTimeMoadal, setTimeModal] = useState(false); //state to open time picker popup
  const [typeOfSlot, settypeOfSlot] = useState(); //state which allow us to know whether we are editing or adding the slot
  const [createdSlotsData, setCreatedSlotsDate] = useState({});
  const [loader, setLoader] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [slotSuccessModal, setSlotSuccessModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteTitle, setDeleteTitle] = useState("");
  const [timeTitle, setTimeTitle] = useState("");
  const [openDelayMarkedPopup, setOpenDelayMarkedPopup] = useState(false);
  const [scheduleId, setScheduleId] = useState("");

  const doctor_context = useContext(DoctorContext);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  //use effect to get the all the time slots for tele consultation and inclinic consultation
  //slot id is setted whlie calling "get-consultation-settings-rev" and "get-procedure".so after setting the slot_id we are passing to useEffect
  useEffect(() => {
    if (
      consultationType.id != "4" &&
      slotValue != null &&
      slotValue != undefined &&
      Object.keys(slotValue).length !== 0
    ) {
      getSlotsByConsultation();
    }
  }, [
    consultationType,
    slotValue,
    consultationCounter,
    doctor_context?.clinic_id,
  ]);

  function getSlotsByConsultation() {
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: "/clinic/get-slots-by-consultation-type",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id:
            doctorRole == USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType == APPLICABLE_ROLE.STAFF
              ? staffDoctor.id
              : userId,
          clinic_id: doctor_context?.clinic_id,
          consultation_type: consultationType.value,
          slot_type: slotValue.slotType, //slotValue.id
        },
      })
        .then((response) => {
          if (response.data.statusCode == 200) {
            if (response.data.RequestData.length > 0) {
              setAvailableSlots(response.data.RequestData);
              setLoader(false);
            } else {
              setAvailableSlots([]);
              setLoader(false);
            }
          } else {
            setAvailableSlots([]);
            setLoader(false);
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    } else {
      setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: "/doctor/get-slots-by-consultation-type",
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          doctor_id:
            userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
          consultation_type: consultationType.value,
          slot_type: slotValue.slotType, //slotValue.id
        },
      })
        .then((response) => {
          if (response.data.statusCode == 200) {
            if (response.data.RequestData.length > 0) {
              setAvailableSlots(response.data.RequestData);
              setLoader(false);
            } else {
              setAvailableSlots([]);
              setLoader(false);
            }
          } else {
            setAvailableSlots([]);
            setLoader(false);
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
  }

  //use effect to get the all the time slots for procedure consultation
  useEffect(() => {
    if (
      consultationType.id == "4" &&
      slotValue != null &&
      slotValue != undefined &&
      Object.keys(slotValue).length !== 0 &&
      !commonProcedure
    ) {
      getTimeSlotsProcedure();
    }
    if (commonProcedure) {
      setTimeout(function () {
        getTimeSlotsProcedure();
      }, 500);
    }
  }, [consultationType, slotValue, commonProcedure]);

  function getTimeSlotsProcedure() {
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      setLoader(true);
      if (consultationType.value != "4") {
        afterLoginApiAxios({
          method: "post",
          url: "/clinic/get-slots-by-procedure-id",
          headers: {
            authorization: localStorage.getItem("id_token"),
          },
          data: {
            doctor_id:
              doctorRole == USER_ROLE.DOCTOR_ADMIN ||
              doctorRole === USER_ROLE.RESOURCE_ADMIN ||
              userType == APPLICABLE_ROLE.STAFF
                ? staffDoctor.id
                : userId,
            clinic_id: doctor_context?.clinic_id,
            slot_type: slotValue.slotType,
            consultation_type: consultationType.id,
            procedure_id: consultationType.value,
          },
        })
          .then((response) => {
            if (response.data.statusCode == 200) {
              if (response.data.RequestData.length > 0) {
                setAvailableSlots(response.data.RequestData);
                setLoader(false);
              } else {
                setLoader(false);
                setAvailableSlots([]);
              }
            } else {
              setAvailableSlots([]);
              setLoader(false);
            }
          })
          .catch((error) => {
            C2CConsole.error(error);
          });
      } else {
        setLoader(false);
        setAvailableSlots([]);
      }
    } else {
      setLoader(true);
      if (consultationType.value != "4") {
        afterLoginApiAxios({
          method: "post",
          url: "/doctor/get-slots-by-procedure-id",
          headers: {
            authorization: localStorage.getItem("id_token"),
          },
          data: {
            doctor_id:
              userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
            slot_type: slotValue.slotType,
            consultation_type: consultationType.id,
            procedure_id: consultationType.value,
          },
        })
          .then((response) => {
            if (response.data.statusCode == 200) {
              if (response.data.RequestData.length > 0) {
                setAvailableSlots(response.data.RequestData);
                setLoader(false);
              } else {
                setLoader(false);
                setAvailableSlots([]);
              }
            } else {
              setAvailableSlots([]);
              setLoader(false);
            }
          })
          .catch((error) => {
            C2CConsole.error(error);
          });
      } else {
        setLoader(false);
        setAvailableSlots([]);
      }
    }
  }

  function handleOpenTimerModal() {
    if (!openTimeMoadal) setTimeModal(true);
  }

  function handleCloseTimeModal() {
    setTimeModal(false);
  }

  function deleteSlots(data) {
    let delete_url_consultation = "";
    let delete_url_procedure = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      delete_url_consultation = "/clinic/delete-slots-by-consultation-type";
      delete_url_procedure = "/clinic/delete-slots-by-procedure-id";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          userType == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    } else {
      delete_url_consultation = "/doctor/delete-slots-by-consultation-type";
      delete_url_procedure = "/doctor/delete-slots-by-procedure-id";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    }
    if (consultationType.id !== "4") {
      afterLoginApiAxios({
        method: "post",
        url: delete_url_consultation,
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          ...payload,
          consultation_type: consultationType.id,
          start_time: moment(data.start_time, "HH:mm:ss").format("hh:mm A"),
          end_time: moment(data.end_time, "HH:mm:ss").format("hh:mm A"),
          days_of_week: data.days,
          slot_type: slotValue.slotType,
          start_date: data?.start_date,
          end_date: data?.end_date,
        },
      })
        .then((response) => {
          if (response.data.statusCode == 200) {
            setDeleteTitle(response.data.message);
            setDeleteModal(true);
            getSlotsByConsultation();
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    } else {
      afterLoginApiAxios({
        method: "post",
        url: delete_url_procedure,
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          ...payload,
          consultation_type: consultationType.id,
          procedure_id: consultationType.value,
          start_time: moment(data.start_time, "HH:mm:ss").format("hh:mm A"),
          end_time: moment(data.end_time, "HH:mm:ss").format("hh:mm A"),
          days_of_week: data.days,
          slot_type: slotValue.slotType,
          start_date: data?.start_date,
          end_date: data?.end_date,
        },
      })
        .then((response) => {
          if (response.data.statusCode == 200) {
            setDeleteTitle(response.data.message);
            setDeleteModal(true);
            getTimeSlotsProcedure();
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
  }

  function handleTitle(data) {
    setTimeTitle(data);
  }

  // Actions ===>

  const handleDelayMarkedPopup = (id) => {
    if (window.innerWidth > 767) {
      setScheduleId(id);
      setOpenDelayMarkedPopup(true);
    } else {
      handleShowDelayMarkedPopup(id);
    }
  };

  const handleClosePopup = () => {
    setOpenDelayMarkedPopup(false);
  };

  // <===

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div>
            {availableSlots.length == 0 ? (
              <div>
                <p className="consultation-title font-weight-bold m-0 px-sm-0 px-lg-3 px-0">
                  Please add slots for {consultationType.label} appointments
                </p>
              </div>
            ) : null}
            {availableSlots.length > 0
              ? availableSlots.map((data, index) => (
                  <div key={index} className="mx-lg-3 mx-0">
                    <div className="d-flex ai-center mb-0">
                      <div className="range_picker_root m-0">
                        <div className="picker">
                          <Button
                            variant={"light"}
                            className="start_time"
                            onClick={() => {
                              setCreatedSlotsDate(data);
                              handleOpenTimerModal();
                              settypeOfSlot("edit");
                            }}
                          >
                            {moment(data.start_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                          </Button>
                          <div className="connector">to</div>
                          <Button
                            variant={"light"}
                            className="end_time"
                            onClick={() => {
                              setCreatedSlotsDate(data);
                              handleOpenTimerModal();
                              settypeOfSlot("edit");
                            }}
                          >
                            {moment(data.end_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                          </Button>
                        </div>
                        <div className="time_range_icons">
                          <img
                            src={Visibility}
                            onClick={handleViewSlots}
                            alt="visibility"
                          />
                          <div className="divider"></div>
                          <img
                            src={RedTrash}
                            onClick={() => deleteSlots(data)}
                            alt="delete"
                          />
                        </div>
                      </div>
                      {data.delay_marked_for && (
                        <div
                          data-tooltip="Delay Marked for"
                          data-tooltip-conf="bottom"
                          className="delay-marked-info-icon"
                          style={{ marginLeft: "15px", cursor: "pointer" }}
                        >
                          <img
                            src={info_icon}
                            alt=""
                            onClick={() =>
                              handleDelayMarkedPopup(data.doctor_schedule_id)
                            }
                          />
                        </div>
                      )}
                    </div>
                    <p className="mt-1 consultation-title">
                      <span>
                        {data?.start_date &&
                          moment(data?.start_date).format("MMMM DD, YYYY")}
                      </span>
                      <span> - </span>
                      <span>
                        {data?.start_date &&
                          moment(data?.end_date).format("MMMM DD, YYYY")}
                        ,{" "}
                      </span>
                      {data.days.map((dd, indx) => (
                        <span key={indx}>
                          {DAYS_OF_WEEK[dd]}
                          {data.days.length > 1
                            ? indx != data.days.length - 1
                              ? ", "
                              : ""
                            : ""}
                        </span>
                      ))}
                    </p>
                  </div>
                ))
              : null}

            <div className={"add_new_range mt-2"}>
              <div
                className={"add_range font-weight-bold px-sm-0 px-lg-3 px-0"}
              >
                <span
                  className={
                    consultationType.value == "4" || disableAddBtn
                      ? "disabledSlots"
                      : "enabledSlots"
                  }
                  onClick={() => {
                    handleOpenTimerModal();
                    settypeOfSlot("add");
                  }}
                >
                  <i
                    className={"fa fa-plus-circle"}
                    style={{ marginRight: "5px" }}
                  />
                  {availableSlots.length > 0 ? "Add More Slots" : "Add Slots"}
                </span>
              </div>
            </div>
          </div>
          <div className="add-time-picker-modal">
            <TimePickerModal
              typeOfSlot={typeOfSlot}
              open={openTimeMoadal}
              handleCloseTimeModal={handleCloseTimeModal}
              consultationType={consultationType}
              slotValue={slotValue}
              // createdSlots={createdSlots}
              createdSlotsData={createdSlotsData}
              getTimeSlotsProcedure={getTimeSlotsProcedure}
              getSlotsByConsultation={getSlotsByConsultation}
              handleSaveTimerModal={() => {
                if (consultationType.id != "4") {
                  setTimeModal(false);
                  getSlotsByConsultation();
                  setSlotSuccessModal(true);
                } else {
                  setTimeModal(false);
                  getTimeSlotsProcedure();
                  setSlotSuccessModal(true);
                }
              }}
              handleTitle={handleTitle}
              staffDoctor={staffDoctor}
            />
          </div>
        </>
      )}
      <MyScheduleModal
        show={slotSuccessModal}
        procedureName={consultationType.label}
        title={timeTitle}
        okayClickHandler={() => {
          setSlotSuccessModal(false);
        }}
        name="timeRangeModal"
      />
      <MyScheduleModal
        show={deleteModal}
        subtitle={deleteTitle}
        okayClickHandler={() => {
          setDeleteModal(false);
        }}
        name="DeleteModal"
        procedureName={consultationType.label}
      />
      {window.innerWidth > 767 && openDelayMarkedPopup && (
        <DelayMarkedPopup
          openDelayMarkedPopup={openDelayMarkedPopup}
          scheduleId={scheduleId}
          handleClosePopup={handleClosePopup}
        />
      )}
    </>
  );
}

export default AddTimeRange;
